import React from 'react'

import { Check } from 'lucide-react'

import { useTranslation } from '@/core/i18n/useTranslation'

interface Feature {
	key: string
	label: string
	essential: boolean | string // Can be boolean (for checkmark) or string (for custom text)
	advanced: boolean | string
}

export const ComparePlans: React.FC = () => {
	const { t } = useTranslation('common')

	const features: Feature[] = [
		{
			key: 'calendars',
			label: t('subscribe.features.calendars'),
			essential: true,
			advanced: true,
		},
		{
			key: 'playlists',
			label: t('subscribe.features.playlists'),
			essential: true,
			advanced: true,
		},
		{
			key: 'schedules',
			label: t('subscribe.features.schedules'),
			essential: false,
			advanced: true,
		},
		{
			key: 'campaigns',
			label: t('subscribe.features.campaigns'),
			essential: t('subscribe.features.essential_campaigns'),
			advanced: t('subscribe.features.advanced_campaigns'),
		},
		{
			key: 'integrations',
			label: t('subscribe.features.integrations'),
			essential: t('subscribe.features.essential_integrations'),
			advanced: t('subscribe.features.advanced_integrations'),
		},
		{
			key: 'support',
			label: t('subscribe.features.support'),
			essential: false,
			advanced: true,
		},
	]

	const renderCell = (value: boolean | string) => {
		if (typeof value === 'string') {
			return <span className="text-sm text-muted-foreground">{value}</span>
		}
		if (value === true) {
			return <Check className="h-5 w-5 text-primary" />
		}
		return null
	}

	return (
		<div className="mt-12">
			<h2 className="text-2xl font-semibold mb-6">
				{t('subscribe.compare_plans')}
			</h2>

			<div className="border border-border rounded-xl overflow-hidden">
				{/* Header */}
				<div className="grid grid-cols-3 bg-muted/50">
					<div className="p-4 font-medium text-muted-foreground">
						{t('subscribe.features_label')}
					</div>
					<div className="p-4 font-medium text-center">
						{t('subscribe.plans.essential')}
					</div>
					<div className="p-4 font-medium text-center">
						{t('subscribe.plans.advanced')}
					</div>
				</div>

				{/* Features */}
				{features.map((feature, index) => (
					<div
						key={feature.key}
						className={`grid grid-cols-3 ${
							index < features.length - 1 ? 'border-b border-border' : ''
						}`}
					>
						<div className="p-4 text-sm">{feature.label}</div>
						<div className="p-4 flex justify-center items-center">
							{renderCell(feature.essential)}
						</div>
						<div className="p-4 flex justify-center items-center">
							{renderCell(feature.advanced)}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default ComparePlans
